import React from "react";
import "./about.scss";
import logo from "../../../Media/homeimages/Lyndon 19.webp";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6282122005507&text=Halo%20Dean,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20BSD%20City%20https://bsdcity-marketing.id//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const about = () => {
  return (
    <div id="about" className="container-about">
      <div className="container-deskripsi">
        <div className="judulsumbog">
          <h1>Live, work and play in one city</h1>
        </div>
        <div className="deskripsi-about">
          BSD City (Bumi Serpong Damai City) adalah salah satu kawasan kota
          terencana terbesar di Indonesia yang terletak di wilayah Tangerang
          Selatan, Banten. Proyek ini dikembangkan oleh Sinarmas Land, salah
          satu pengembang properti terkemuka di Indonesia. Dengan luas area
          lebih dari 6.000 hektar, BSD City dirancang sebagai kota mandiri yang
          mengintegrasikan berbagai aspek kehidupan modern, seperti hunian,
          komersial, pendidikan, rekreasi, dan transportasi.
        </div>
      </div>
      <div className="rowcontainer">
        <div className="featurelist">
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "#5a5a5a"}}>
              &nbsp;&nbsp; Strategic Location
            </span>
          </div>
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "#5a5a5a"}}>
              &nbsp;&nbsp;Engage with Daily Life Activity
            </span>
          </div>
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "#5a5a5a"}}>
              &nbsp;&nbsp;Clubhouse Every Cluster
            </span>
          </div>

          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "#5a5a5a"}}>
              &nbsp;&nbsp;Elegant Lifestyle
            </span>
          </div>

          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "#5a5a5a"}}>
              &nbsp;&nbsp;Endless Facilities
            </span>
          </div>
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "#5a5a5a"}}>
              &nbsp;&nbsp;Perfect Modern Luxury & luxurious Residence
            </span>
          </div>
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "#5a5a5a"}}>
              &nbsp;&nbsp;Where Education is Always Within Reach
            </span>
          </div>
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "#5a5a5a"}}>
              &nbsp;&nbsp;Your Health, Always Within Reach
            </span>
          </div>
          <div className="button">
            <div className="container-wa">
              <button
                className="buttonpenawaran"
                onClick={handleConsultationClick}>
                Learn More
              </button>
            </div>
          </div>
        </div>
        <div className="logo-about">
          <img
            className="gambar-logo"
            src={logo}
            alt="logo-summarecon-serpong"
          />
        </div>
      </div>
    </div>
  );
};

export default about;
